<script setup>
import {useConfigStore} from '@core/stores/config'

const props = defineProps({
  themes: {
    type: Array,
    required: true,
  },
})

const configStore = useConfigStore()
const selectedItem = ref([configStore.theme])

// Update icon if theme is changed from other sources
watch(() => configStore.theme, () => {
  selectedItem.value = [configStore.theme]
}, {deep: true})
</script>

<template>
  <VAvatar
    class="cursor-pointer mr-3"
    variant="tonal"
  >
    <VIcon :icon="props.themes.find(t => t.name === configStore.theme)?.icon"/>

    <VTooltip
      activator="parent"
      open-delay="1000"
      scroll-strategy="close"
    >
      <span class="text-capitalize">{{ configStore.theme }}</span>
    </VTooltip>

    <VMenu

      :width="180"
      activator="parent"
      offset="12px"
    >
      <VList
        v-model:selected="selectedItem"
        mandatory
      >
        <VListItem
          v-for="{ name, icon } in props.themes"
          :key="name"
          :prepend-icon="icon"
          :value="name"
          color="primary"
          @click="() => { configStore.theme = name }"
        >
          <VListItemTitle class="text-capitalize">
            {{ name }}
          </VListItemTitle>
        </VListItem>
      </VList>
    </VMenu>
  </VAvatar>
</template>
